import { Box, Grid } from '@material-ui/core'
import { ReactComponent as HomeIcon, ReactComponent as ImportIcon } from 'img/ptStock.svg'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { INVENTORY_STEPS } from 'shared'
import { SquareButton } from './SquareButton'

export const FinishImport = (): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()

  const setStep = useInventoryStore((state) => state.setStep)
  const setPtInventoryLoaded = useInventoryStore((state) => state.setPtInventoryLoaded)
  const setCurrentPtInventory = useInventoryStore((state) => state.setCurrentPtInventory)
  const setNumConflicts = useInventoryStore((state) => state.setNumConflicts)
  const setNumSolvedConflicts = useInventoryStore((state) => state.setNumSolvedConflicts)
  const setDiffSelectedArticles = useInventoryStore((state) => state.setDiffSelectedArticles)

  const resetInventoryStoreState = () => {
    setCurrentPtInventory([])
    setPtInventoryLoaded(false)
    setDiffSelectedArticles([])
    setNumConflicts(0)
    setNumSolvedConflicts(0)
  }

  return (
    <>
      <Box>
        <Box className="title">
          <div className="titleFont">{t('ptInventory.finish.title')}</div>
        </Box>
        <Box marginY={5} />
        <Box marginY={2}>
          <div className="bodyFont">{t('ptInventory.finish.text1')}</div>
        </Box>

        <Box marginY={5} />

        <Grid container className="gridContainer">
          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <SquareButton
              image={<HomeIcon />}
              text={t('ptInventory.finish.goToHome')}
              type="primary"
              handleClick={() => {
                resetInventoryStoreState()
                history.push('/')
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <SquareButton
              image={<ImportIcon />}
              text={t('ptInventory.finish.anotherImport')}
              type="secondary"
              handleClick={() => {
                resetInventoryStoreState()
                setStep(INVENTORY_STEPS.WELCOME.idx)
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
